// @flow
import NumberSwitcher from './NumberSwitcher';

export default NumberSwitcher;
